var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _path3, _circle, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line, _line2, _circle2, _circle3, _circle4, _circle5, _path14, _path15, _ellipse11, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnySnail4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#7BD5F5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 80,
    rx: 50,
    ry: 30,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 65,
    rx: 40,
    ry: 25,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 80,
    rx: 45,
    ry: 30,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 50,
    rx: 60,
    ry: 35,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 350,
    cy: 40,
    rx: 40,
    ry: 25,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 55,
    rx: 50,
    ry: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,250 C100,240 200,260 300,245 C350,237 400,245 400,245 L400,300 L0,300 Z",
    fill: "#F2D16B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 C110,220 170,220 230,220 C290,220 320,230 320,230 L320,260 C260,255 200,255 140,255 C80,255 50,260 50,260 Z",
    fill: "#F0D6AC",
    stroke: "#DB9B48",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 C40,210 50,190 70,190 C90,190 100,210 90,230",
    fill: "#F0D6AC",
    stroke: "#DB9B48",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 170,
    r: 70,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 50,
    ry: 40,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 35,
    ry: 28,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 20,
    ry: 16,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230,120 C240,130 245,140 240,160 L226,165 C230,145 225,135 215,125 Z",
    fill: "#FED3A1",
    stroke: "#D68910",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220,118 C235,118 240,125 245,130",
    fill: "none",
    stroke: "#D68910",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218,122 C226,125 233,128 238,135",
    fill: "none",
    stroke: "#D68910",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130,100 L150,120",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100,150 L120,160",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110,210 L130,195",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240,210 L220,195",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250,160 L230,160",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240,120 L220,135",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190,100 L180,120",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 190,
    x2: 50,
    y2: 150,
    stroke: "#DB9B48",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 190,
    x2: 90,
    y2: 150,
    stroke: "#DB9B48",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 150,
    r: 12,
    fill: "white",
    stroke: "#000",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 150,
    r: 12,
    fill: "white",
    stroke: "#000",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 150,
    r: 5,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 150,
    r: 5,
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40,140 L55,135",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85,135 L100,140",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 210,
    rx: 10,
    ry: 15,
    fill: "#EC7063",
    stroke: "#A04000",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 135,
    fontFamily: "Arial",
    fontSize: 40,
    fontWeight: "bold"
  }, "!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnySnail4);
export default __webpack_public_path__ + "static/media/funny-snail4.7826d0da7b189698a7b9b3803f215050.svg";
export { ForwardRef as ReactComponent };